import React from 'react';
import PropTypes from 'prop-types';
import {MediaType} from '@learningblocks/storybook-components';
import {VIEW_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import {SliderWeb} from './SliderWeb';
import {SliderMob} from './SliderMob';
import {Header, SubHeading, Wrapper, SubmitButton} from './SliderComponents';

import './style.scss';

export function SliderWidget(props) {
  const mediaType = React.useContext(MediaType.Context);

  const getAnimeData = (animationData) => ({
    animation: {isPath: props.animation.isPath, animationData},
  });

  const renderByMediaType = () => {
    switch (mediaType) {
      case VIEW_TYPE.MOB:
        return (
          <SliderMob
            key='mob'
            {...props}
            {...getAnimeData(props.animation.mobAnime)}
          />
        );
      case VIEW_TYPE.TAB:
        return (
          <SliderMob
            key='tab'
            {...props}
            {...getAnimeData(props.animation.tabAnime)}
          />
        );
      case VIEW_TYPE.WEB:
        return (
          <SliderWeb
            key='web'
            {...props}
            {...getAnimeData(props.animation.webAnime)}
          />
        );
      default:
        return (
          <SliderWeb
            key='web'
            {...props}
            //{...args}
            {...getAnimeData(props.animation.webAnime)}
          />
        );
    }
  };

  const className = `slider ${props.className}`;

  return (
    <Wrapper className={className}>
      <Header className='slider_header' text={props.headerText} />
      <SubHeading text={props.subHeading} />
      {renderByMediaType()}
      <SubmitButton
        showSubmit={props.showSubmit}
        onClick={props.onSubmit}
        text='Submit Answer'
      />
    </Wrapper>
  );
}

SliderWidget.propTypes = {
  /**
   * Header text for slider widget
   */
  headerText: PropTypes.string,
  /**
   * SubHeading text for the slider widget
   */
  subHeading: PropTypes.string,
  /**
   * animation file for slider widget
   */
  animation: PropTypes.object,
  /**
   * minimum value possible
   */
  min: PropTypes.number,
  /**
   * maximum value possible
   */
  max: PropTypes.number,
  /**
   * show submit button
   */
  showSubmit: PropTypes.bool,
  /**
   * specifies type of value provided
   */
  valueType: PropTypes.oneOf(['precise', 'vague']),
  /**
   * function to invoke when slider value is chagned
   */
  onChange: PropTypes.func,
  /**
   * current value of slider
   */
  value: PropTypes.number,
  /**
   * heading above animation
   */
  animationText: PropTypes.string,
  /**
   * text displayed above slider
   */
  sliderText: PropTypes.string,
  /**
   * aria label for animation
   */
  animeAriaLabel: PropTypes.string,
  /**
   * aria label for range slider
   */
  sliderAriaLabel: PropTypes.string,
  /**
   * specifies how much units is one step for rangeSlider
   */
  step: PropTypes.number,
  /**
   * Function to invoke when submit button is pressed
   */
  onSubmit: PropTypes.func,
  /**
   *  Style from outside the component
   */
  className: PropTypes.string,
};

SliderWidget.defaultProps = {
  headerText: 'EXPLORE',
};
